export default __webpack_public_path__ + "static/media/Pistol_3.4a3db267.png";